import { isNil } from 'lodash';
import CodeBlockNotePresentation from '../../constants/simulation/codeBlockNotePresentation';
import IconBlockNotePresentation from '../../constants/simulation/iconBlockNotePresentation';
import type LigneNotePresentation from '../../interfaces/simulation/ligneNotePresentation';

// Les titres de la note portent leur texte dans le contenu court, le paragraphe
// porte son intertitre dans le titre du bloc
const CHAMPS_TITRE: Partial<
	Record<CodeBlockNotePresentation, 'contenuCourt' | 'titre'>
> = {
	[CodeBlockNotePresentation.TITRE]: 'contenuCourt',
	[CodeBlockNotePresentation.SOUS_TITRE]: 'contenuCourt',
	[CodeBlockNotePresentation.PARAGRAPHE]: 'titre',
};

const ICONES_BLOC: Record<
	CodeBlockNotePresentation,
	IconBlockNotePresentation
> = {
	[CodeBlockNotePresentation.TITRE]: IconBlockNotePresentation.CHAMP_LIBRE,
	[CodeBlockNotePresentation.SOUS_TITRE]: IconBlockNotePresentation.CHAMP_LIBRE,
	[CodeBlockNotePresentation.PARAGRAPHE]: IconBlockNotePresentation.CHAMP_LIBRE,
	[CodeBlockNotePresentation.TEXTE]: IconBlockNotePresentation.TEXTE,
	[CodeBlockNotePresentation.SECTION_FONCTIONNEMENT]:
		IconBlockNotePresentation.TEXTE,
	[CodeBlockNotePresentation.GRAPHIQUE]: IconBlockNotePresentation.GRAPHIQUE,
	[CodeBlockNotePresentation.TABLEAU]: IconBlockNotePresentation.TABLEAU,
	[CodeBlockNotePresentation.COMPARATIF]: IconBlockNotePresentation.TABLEAU,
	[CodeBlockNotePresentation.RATIO]: IconBlockNotePresentation.RATIO,
};

// Seuls les champs libres ont un contenu saisi, les autres blocs sont alimentés
// à partir des données de la simulation
export const estChampLibre = (codeBlock: string): boolean =>
	!isNil(CHAMPS_TITRE[codeBlock as CodeBlockNotePresentation]);

export const getIconeBloc = (codeBlock: string): IconBlockNotePresentation =>
	ICONES_BLOC[codeBlock as CodeBlockNotePresentation] ??
	IconBlockNotePresentation.AUTRE;

// Le libellé affiché dans la liste des blocs est le texte imprimé en tête du
// bloc, il ne porte pas le même champ selon le type de champ libre
export const getTitreLigne = (ligne?: LigneNotePresentation): string => {
	const champTitre =
		CHAMPS_TITRE[ligne?.codeBlock as CodeBlockNotePresentation];

	return champTitre ? (ligne[champTitre] ?? '') : '';
};

export const ordonnerLignes = (
	lignes?: LigneNotePresentation[],
): LigneNotePresentation[] =>
	[...(lignes ?? [])].sort((a, b) => a.ordre - b.ordre);
